import * as React from 'react';
import { Icon } from 'semantic-ui-react';

export interface AddMessageProps {
  showAddMessageSection(): void;
  isAddMessagesInProgress: boolean;
}



export class AddMessage extends
  React.Component<AddMessageProps, {}> {


  onAddClick = () => {
    this.props.showAddMessageSection();
  }


  render() {
    const { isAddMessagesInProgress } = this.props;
    return (
      <div className="addMessage">
        <a onClick={this.onAddClick}>
          <Icon 
            name="plus" 
            className={isAddMessagesInProgress ? 'addMessage-icon-active' : 'addMessageIcon'} 
            id="addMessageButton" 
          />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AddMessage/AddMessage.tsx